import moment from 'moment';

export default {
    data() {
        return {
            tempSelectedDates: [],
        }
    },
    methods: {
        closeDatepicker() {
            this.$refs.searchDateRange.closePopup();
        },
        clearDatepicker() {
            this.tempSelectedDates = [];
            this.searchForm.dateRange = null;
        },
        datePicked(date) {
            const formatDate = moment(date).format('MM-DD-YYYY');
            if (!this.oneDatePicked) {
                this.tempSelectedDates.push(formatDate);
                this.searchForm.dateRange = [formatDate, formatDate]
            } else if (this.oneDatePicked) {
                this.tempSelectedDates.push(formatDate);
                this.searchForm.dateRange = [
                    this.tempSelectedDates[0],
                    this.tempSelectedDates[1]
                ];
                this.closeDatepicker();
            }
        }
    },
    computed: {
        oneDatePicked() {
            return this.tempSelectedDates.length === 1;
        }
    }
}
